import React from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { interactionAPI } from '../../api';

export const NotesTab = ({
  id,
  interactions,
  showNoteModal,
  setShowNoteModal,
  newNoteContent,
  setNewNoteContent,
  fetchLoadData,
}) => {
  return (
    <>
              <div className="bg-[var(--tms-card)] border border-[var(--tms-border)] rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-semibold text-[var(--tms-text)]">NOTES & INTERACTIONS</h3>
                  <Button size="sm" onClick={() => setShowNoteModal(true)} data-testid="add-note-button">
                    <Plus className="w-3 h-3 mr-1" /> Add Note
                  </Button>
                </div>
                
                {/* Add Note Modal */}
                {showNoteModal && (
                  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowNoteModal(false)}>
                    <div className="bg-[var(--tms-card)] rounded-lg p-6 w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
                      <h4 className="text-lg font-semibold mb-4">Add Note</h4>
                      <Textarea placeholder="Enter your note here..." value={newNoteContent} onChange={(e) => setNewNoteContent(e.target.value)} className="mb-4" rows={4} data-testid="note-content-input" autoFocus />
                      <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={() => { setShowNoteModal(false); setNewNoteContent(''); }} data-testid="cancel-note-button">Cancel</Button>
                        <Button onClick={() => { if (newNoteContent.trim()) { interactionAPI.create({ entity_type: 'load', entity_id: id, interaction_type: 'note', subject: 'Load Note', content: newNoteContent.trim(), attachments: [] }).then(() => { toast.success('Note added'); fetchLoadData(); setShowNoteModal(false); setNewNoteContent(''); }).catch(() => toast.error('Failed to add note')); } }} disabled={!newNoteContent.trim()} data-testid="save-note-button">Save Note</Button>
                      </div>
                    </div>
                  </div>
                )}

                {interactions.length === 0 ? (
                  <p className="text-[var(--tms-text-muted)] text-center py-8">No notes yet</p>
                ) : (
                  <div className="space-y-2 max-h-[500px] overflow-y-auto">
                    {interactions.map(inter => (
                      <div key={inter.id} className="border border-[var(--tms-border)] rounded-lg p-3 bg-[var(--tms-hover)]" data-testid={`interaction-${inter.id}`}>
                        <div className="flex items-center justify-between mb-1">
                          <p className="font-medium text-sm text-[var(--tms-text)]">{inter.subject}</p>
                          <span className="text-xs text-[var(--tms-text-muted)]">{new Date(inter.created_at).toLocaleString()}</span>
                        </div>
                        <p className="text-sm text-[var(--tms-text-secondary)]">{inter.content}</p>
                        <p className="text-xs text-[var(--tms-text-muted)] mt-1">By: {inter.created_by_name}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
    </>
  );
};

export default NotesTab;
